var map = {
	"./Discord-active.png": "oxTI",
	"./Facebook-active.png": "38lg",
	"./Instagram-active.png": "Fu1O",
	"./Naver-active.png": "Cilu",
	"./TikTok-active.png": "DYPS",
	"./Twitch-active.png": "0sCr",
	"./VK-active.png": "yykD",
	"./X-active.png": "Isbn",
	"./YouTube-active.png": "PAym",
	"./border-active.png": "e6r3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BVWW";